import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { useScriptMode } from "../../../contexts/ScriptModeContext";

export default function RemovePersonConfirm({ open, onClose, onConfirm, loading }) {
  const { t } = useScriptMode();
  return (
    <Dialog open={!!open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{t("manage_remove_person_confirm_title")}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t("manage_remove_person_confirm_body")}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          {t("manage_remove_person_cancel")}
        </Button>
        <Button color="error" variant="contained" onClick={onConfirm} disabled={loading}>
          {t("manage_remove_person_cta")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
